import initialState from '../store/initial-state'
import {
  MULTISELECT_ADD_ITEM,
  MULTISELECT_ADD_ALL,
  MULTISELECT_REMOVE_ITEM,
  MULTISELECT_CLEAR,
  UPDATE_MODAL_VISIBILITY
} from '../constants/multiselect-action-types'

export default (state = initialState.selectedFiles, action) => {
  switch (action.type) {

    
    case MULTISELECT_CLEAR:
      return {
        ...state,
        data: [],
      }
    case MULTISELECT_ADD_ALL:
      return {
        ...state,
        data: action.payload.data,
        keyCollection: action.payload.keyCollection
      }
    case MULTISELECT_ADD_ITEM:
      return {
        ...state,
        data: [...state.data.filter(item => item._id !== action.payload.data._id), action.payload.data],
        keyCollection: action.payload.keyCollection
      }
    case MULTISELECT_REMOVE_ITEM:
      return {
        ...state,
        data: [...state.data.filter(item => item._id !== action.payload.data._id)],
        keyCollection: action.payload.keyCollection
      }
    case UPDATE_MODAL_VISIBILITY:
      return {
        ...state,
        ...action.payload
      }
    default: return { ...state }
  }
}